import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type MemberActivityWorkspacesFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id'>
  & { organizations: Array<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id' | 'displayName' | 'idEnterprise' | 'name' | 'offering'>
    & { prefs: (
      { __typename: 'Organization_Prefs' }
      & Pick<Types.Organization_Prefs, 'permissionLevel'>
    ) }
  )> }
);

export const MemberActivityWorkspacesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MemberActivityWorkspaces' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idEnterprise' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offering' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prefs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'permissionLevel' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseMemberActivityWorkspacesFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      MemberActivityWorkspacesFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseMemberActivityWorkspacesFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<MemberActivityWorkspacesFragment>,
    'data'
  > {
  data?: MemberActivityWorkspacesFragment;
}

export const useMemberActivityWorkspacesFragment = ({
  from,
  returnPartialData,
  ...options
}: UseMemberActivityWorkspacesFragmentOptions): UseMemberActivityWorkspacesFragmentResult => {
  const result = Apollo.useFragment<MemberActivityWorkspacesFragment>({
    ...options,
    fragment: MemberActivityWorkspacesFragmentDoc,
    fragmentName: 'MemberActivityWorkspaces',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as MemberActivityWorkspacesFragment };
};
